import {
  Accordion as FumadocsAccordion,
  Accordions,
} from "fumadocs-ui/components/accordion";
import type { ReactNode } from "react";

type AccordionProps = {
  title: string;
  children: ReactNode;
};

export function Accordion({ children, title }: AccordionProps) {
  return (
    <Accordions type="single">
      <FumadocsAccordion title={title}>{children}</FumadocsAccordion>
    </Accordions>
  );
}
